import React, { useEffect, useState } from 'react';
import { ExternalDataService } from '../../services/external-data';
import { StockInformationCategory } from '../../services/external-data/types';
import { Props } from '../types';
import { filterProps } from '../helpers';

interface StockPriceResponse {
  Currency: string,
  Price: number,
  Change: number,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'Change Percentage': number,
}

const isValid = (input): boolean => (input !== undefined && input !== 'N/A' && input !== '#N/A');

export const RocheStockPrice = ({ blok, slot }: Props): JSX.Element => {
  const { props } = filterProps(blok);
  const [state, setState] = useState(null);

  useEffect(() => {
    ExternalDataService.getStockInformation({ category: StockInformationCategory.SWX_ROG })
      .then((result: StockPriceResponse) => setState(result));
  }, []);

  if (!state) {
    return null;
  }

  const {
    Price: price, Currency: currency, Change: change, 'Change Percentage': changePercentage,
  } = state;

  const unavailable: boolean = Number.isNaN(price)
    || !isValid(currency)
    || Number.isNaN(change)
    || Number.isNaN(changePercentage);

  return (
    <roche-stock-price
      price={price}
      currency={currency}
      change={change}
      relative-change={changePercentage}
      href={props?.href}
      slot={slot}
      is-unavailable={unavailable}
    >
    </roche-stock-price>
  );
};
